import { useEffect } from "react";
import { refresh } from "../services/auth.service";
import { useDispatch, useSelector } from "react-redux";
import { setInitialized } from "../store/authSlice";
import Loading from "../pages/common/loading.jsx";

const AuthInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const initialized = useSelector((state) => state.auth.initialized);
  useEffect(() => {
    refresh()
      .catch(() => {})
      .finally(() => dispatch(setInitialized()));
  }, [dispatch]);

  if (!initialized) {
    return <Loading />;
  }
  return children;
};

export default AuthInitializer;
